var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 28.5H21V25H7V28.5ZM7 21.5H21V18H7V21.5ZM3.5 35.5C2.5375 35.5 1.71354 35.1573 1.02813 34.4719C0.342708 33.7865 0 32.9625 0 32V4C0 3.0375 0.342708 2.21354 1.02813 1.52813C1.71354 0.842708 2.5375 0.5 3.5 0.5H17.5L28 11V32C28 32.9625 27.6573 33.7865 26.9719 34.4719C26.2865 35.1573 25.4625 35.5 24.5 35.5H3.5ZM15.75 12.75V4H3.5V32H24.5V12.75H15.75Z",
    fill: "#399E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIconActive);
export default __webpack_public_path__ + "static/media/ReportIconActive.111268158f5a2ba7224f9b4b6e10f5e5.svg";
export { ForwardRef as ReactComponent };